/*var testObject = {
   prop1: 'test',
   prop2: 2,
   prop3: null,
   prop4: undefined,
   prop5: true,
   prop6: false,
   prop7: new File(['file content'], 'my_file.txt'),
   prop8: new Date('05 January 2020 16:52:00 GMT'),
   prop9: {
       prop1: 'test',
       prop2: 2,
       prop3: null,
       prop4: undefined,
       prop5: true,
       prop6: false,
       prop7: ['test', 2, null, undefined, true, false]
   }
};*/

function isJsonObject (v) {
    return !Array.isArray(v) && typeof v === 'object' && !!v && !(v instanceof Blob) && !(v instanceof Date);
}

function convertRecursively (o, func, context = []) {
    if (isJsonObject(o)) {
        for (const key in o) {
            if (o.hasOwnProperty(key)) {
                context.push(key);
                convertRecursively(o[key], func, context);
                context.pop();
            }
        }
    } else if (Array.isArray(o) || o instanceof FileList) {
        for (let j = 0; j < o.length; j++) {
            context.push(j);
            convertRecursively(o[j], func, context);
            context.pop();
        }
    } else {
        func(context, o);
    }
}

function toKey (c) {
    return c.map((v, i) => Number.isInteger(v) ? '[' + v + ']' : (i > 0 ? '.' : '') + v).join('');
}

function addToFormData (formData, c, v) {
    const key = toKey(c);
    console.log(key, v);
    if (v instanceof Blob) {
        formData.append(key, v, v.name);
    } else if (v instanceof Date) {
        formData.append(key, v.toISOString());
    } else if (v == null) {
        formData.append(key, '__NULL__');
    } else {
        formData.append(key, v);
    }
}

export const toFormData = (o, customConvert) => {
    let formData = new FormData();
    convertRecursively(o, (c, v) => {
        if (customConvert) {
            v = customConvert(v, c);
        }
        addToFormData(formData, c, v);
    });
    return formData;
};


// WEBPACK FOOTER //
// ./js/utils/form-data-util.js